import React from "react";

const Footer = () => {
  return (
    <footer className="footer">
      <div>&copy; 2026 Stories Through The Lens</div>
      <div>
        <a href="tel:+917710941124" className="footer-link">
          +91 7710941124
        </a>
        <span className="footer-sep">|</span>
        <a href="mailto:connect@storiesttl.com" className="footer-link">
          connect@storiesttl.com
        </a>
      </div>

      <div>
        <a
          href="https://www.instagram.com/stories_ttl"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-link"
        >
          Instagram
        </a>
        <span className="footer-sep">|</span>
        <a
          href="https://flickr.com/photos/203086348@N02"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-link"
        >
          Flickr
        </a>
      </div>
    </footer>
  );
};

export default Footer;
